import { useGenerateStore } from "@/stores/generate";
import { useInputStore } from "@/stores/input";
import { useCanvasStore } from "@/stores/canvas";
import { useDynamicCreativeStore } from "@/stores/dynamicCreative";
import { useResizeStore } from "@/stores/resize";
import { useTranslateStore } from "@/stores/translate";
import { useAIEditorStore } from "@/stores/aiEditor";
import { useButtonGifStore } from "@/stores/buttonGif";
import { useProductStore } from "@/stores/product";
import { useHistoryStore } from "@/stores/history";
import { useBrandStore } from "@/stores/brand";
import { useSegmentationCanvasStore } from "@/stores/segmentationCanvas";
import { useDoMoreActionsStore } from "@/stores/doMoreActions";
import { useChatMessagesStore } from "@/stores/chat";
import { useFeedStore } from "@/stores/feed";

/**
 * Resets every per-business-profile utility store back to its initial state.
 * Use this when switching business profiles so one profile's creative work
 * does not leak into another. The app store (user, portal, business profiles,
 * selected profile id) is intentionally left untouched.
 */
export function useStoreReset() {
  const resetUtilityStores = () => {
    const stores = [
      useGenerateStore(),
      useInputStore(),
      useCanvasStore(),
      useDynamicCreativeStore(),
      useResizeStore(),
      useTranslateStore(),
      useAIEditorStore(),
      useButtonGifStore(),
      useProductStore(),
      useHistoryStore(),
      useBrandStore(),
      useSegmentationCanvasStore(),
      useDoMoreActionsStore(),
      useChatMessagesStore(),
      useFeedStore(),
    ];

    stores.forEach((store) => store.$reset());
  };

  return { resetUtilityStores };
}
